module.exports = __webpack_public_path__ + "static/media/product-default.d515fb4a.png";